module.exports = __webpack_public_path__ + "static/media/trash.e6bdea22.svg";